module.exports = __webpack_public_path__ + "img/reject-md.72b15a75.svg";